    export function getContentSplitting(text) {
        const comments = [];
        

        text.replace(/<br>/g, '\n');
        
        const twttr = require('twitter-text');
        const segmenter = new Intl.Segmenter("en", { granularity: "grapheme" });

        let end = twttr.default.parseTweet(text).validRangeEnd;
        let graphemes = Array.from(segmenter.segment(text), seg => seg.segment);


        const endOfSentenceChars = ['.', ',', ';', '!', '?', '\n'];

        // if (!endOfSentenceChars.includes(graphemes.slice[end]) && end < graphemes.length) {

        //     const index = graphemes.findIndex((char, i) => endOfSentenceChars.includes(char));
        //     if (index !== -1 && index > end) {
        //         end = index
        //     }else {
        //         return []
        //     }
            
        // }

        let unsafeText = graphemes.slice(end+1).join("");
        console.log('tweetSplittingComments while 0', unsafeText)

        
        let limit = 0;
        let searhchNewSentence = false;

        while (text.length && limit < 10) {
            console.log('tweetSplittingComments while 1', text)
            end = twttr.default.parseTweet(text).validRangeEnd;
            graphemes = Array.from(segmenter.segment(text), seg => seg.segment);

            searhchNewSentence = false;
        
            if (end < graphemes.length) {
                let lastIndexEndOfChar = -1;
                //chercher la dernière occurrence d'un caractère de fin de phrase
                for (let i = end; i >= 0; i--) {
                    if (endOfSentenceChars.includes(graphemes[i])) {
                        lastIndexEndOfChar = i;
                        break;
                    }
                }

                if (lastIndexEndOfChar !== -1) {
                    end = lastIndexEndOfChar;
                }else{
                    searhchNewSentence = true;
                }
            }
            
            
            comments.push(graphemes.slice(0, end+1).join(""));
            if (searhchNewSentence) {
                let index = graphemes.findIndex((char) => endOfSentenceChars.includes(char));
                if (index !== -1) {
                    text = graphemes.slice(index+1).join("");
                } else {
                    text = "";
                }
            }else{
                text = graphemes.slice(end+1).join("");
            }
            

            console.log('tweetSplittingComments while 3', text)
            limit++;
        }

        return comments
        
    }